import React, { useState } from "react";
import "./navbar.css";
import iconimages from "./../../Images/logo.svg";
import { Link } from "react-router-dom";
import icons from "./icon-menu-close.svg";
import cancel from "./icon-menu.svg";

const Navbar = (props) => {
  const [tooglemenu, settooglemenu] = useState(false);

  props.toogle(tooglemenu)
  return (
    <>
    
   
    <div className="header">
      <img className="logos" src={iconimages} alt="imgdtata" />
      <div className="mainheader">
        <img src={iconimages} alt="imgdtata" />
        <div className="line" />
        <ul>
          <li>
            <span>00</span>
            <Link className="Link" to="/">
              HOME
            </Link>
          </li>

          <li>
            <span>02</span>
            <Link className="Link" to="/destination">
              DESTINATIOIN
            </Link>
          </li>

          <li>
            <span>03</span>
            <Link className="Link" to="/crew">
              CREW
            </Link>
          </li>

          <li>
            <span>04</span>
            <Link className="Link" to="/tech">
              TECHNOLOGY
            </Link>
          </li>
        </ul>
      </div>
      
      <div className="icon">
        {!tooglemenu ? (
          <img
            onClick={() => settooglemenu(true)}
            className="iconspage"
            src={cancel}
            alt="datas"
          />
        ) : (
          ""
        )}
        {tooglemenu ? (
          <div className="toogle">
            <img
              onClick={() => settooglemenu(false)}
              className="iconscancel"
              src={icons}
              alt="datas"
            />
            <div className="tooglelist">
              <li onClick={() => settooglemenu(false)}>
                {" "}
                <Link className="Link" to="/">
                  HOME
                </Link>
              </li>
              <li onClick={() => settooglemenu(false)}>
                <Link className="Link" to="/destination">
                  DESTINATIOIN
                </Link>
              </li>
              <li onClick={() => settooglemenu(false)}>
                {" "}
                <Link className="Link" to="/crew">
                  CREW
                </Link>
              </li>
              
              <li onClick={() => settooglemenu(false)}>
                {" "}
                <Link className="Link" to="/tech">
                  TECHNOLOGY
                </Link>
              </li>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
    </>
  );
};

export default Navbar;
